import { Row } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import SpotDealLogo from "../SpotDealLogo";
import NexonicLogo from "../NexonicLogo";

import {
  FooterSection,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Chat,
  Language,
  Copyright,
  FooterGrid,
  FooterColumn,
  FooterLink,
  SpotDealFooterBrand,
} from "./styles";

const Footer = ({ t }: { t: TFunction }) => {
  return (
    <>
      <FooterSection>
        <Container>
          <FooterGrid>
            <FooterColumn>
              <Language>{t("Contact")}</Language>
              <Para>
                {t(
                  "Do you have any question? Feel free to reach out."
                )}
              </Para>
              <a href="mailto:info@nexonicetch.com">
                <Chat>info@nexonicetch.com</Chat>
              </a>
            </FooterColumn>

            <FooterColumn>
              <Language>{t("Company")}</Language>
              <FooterLink to="/#about">About Us</FooterLink>
              <FooterLink to="/#mission">Our Mission</FooterLink>
              <FooterLink to="/#product">Products</FooterLink>
              <FooterLink to="/#contact">Contact</FooterLink>
            </FooterColumn>

            <FooterColumn>
              <SpotDealFooterBrand>
                <SpotDealLogo size={40} showName nameSize="sm" gap={10} />
              </SpotDealFooterBrand>
              <Para>
                A Nexonic platform connecting sellers and buyers of used
                electronics — we don't buy or sell devices directly.
              </Para>
              <FooterLink to="/spotdeal/privacy-policy">
                Privacy Policy
              </FooterLink>
              <FooterLink to="/spotdeal/terms">
                Terms & Conditions
              </FooterLink>
            </FooterColumn>

            <FooterColumn>
              <Language>{t("Address")}</Language>
              <Para>Nexonic Etch Private Limited</Para>
              <Para>386, 2nd Floor Valarmathi Complex</Para>
              <Para>7th Street Cross Cut</Para>
              <Para>Gandhipuram, Coimbatore – 641012</Para>
              <Para>Tamil Nadu, India</Para>
            </FooterColumn>
          </FooterGrid>
        </Container>
      </FooterSection>
      <Extra>
        <Container border={true}>
          <Row justify="space-between" align="middle">
            <NavLink to="/">
              <LogoContainer>
                <NexonicLogo size={36} showName nameSize="sm" gap={8} variant="light" />
              </LogoContainer>
            </NavLink>
            <Copyright>
              © {new Date().getFullYear()} Nexonic Etch Private Limited. All rights
              reserved.
            </Copyright>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
